import React from 'react';

import cx from 'classnames';

import SideDrawer from '../sideDrawer/SideDrawer';

import styles from './AppSkeleton.module.scss';

interface Props {
  children?: React.ReactNode;
  ChildclassName?: string;
}

const AppSkeleton: React.FC<Props> = ({ children, ChildclassName }) => (
  <div className={styles.AppSkeleton}>
    <div className={cx(styles.SideDrawer)}>
      <SideDrawer />
    </div>
    <div className={cx(styles.child, ChildclassName)}>{children}</div>
  </div>
);

export default AppSkeleton;
